var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0H12C15.771 0 17.657 -1.19209e-07 18.828 1.172C19.672 2.015 19.908 3.229 19.974 5.25H0.026C0.092 3.229 0.328 2.015 1.172 1.172C2.343 -1.19209e-07 4.229 0 8 0ZM12 16H8C4.229 16 2.343 16 1.172 14.828C-1.19209e-07 13.657 0 11.771 0 8C0 7.558 9.33651e-08 7.142 0.00200009 6.75H19.998C20 7.142 20 7.558 20 8C20 11.771 20 13.657 18.828 14.828C17.657 16 15.771 16 12 16ZM4 11.25C3.80109 11.25 3.61032 11.329 3.46967 11.4697C3.32902 11.6103 3.25 11.8011 3.25 12C3.25 12.1989 3.32902 12.3897 3.46967 12.5303C3.61032 12.671 3.80109 12.75 4 12.75H8C8.19891 12.75 8.38968 12.671 8.53033 12.5303C8.67098 12.3897 8.75 12.1989 8.75 12C8.75 11.8011 8.67098 11.6103 8.53033 11.4697C8.38968 11.329 8.19891 11.25 8 11.25H4ZM10.5 11.25C10.3011 11.25 10.1103 11.329 9.96967 11.4697C9.82902 11.6103 9.75 11.8011 9.75 12C9.75 12.1989 9.82902 12.3897 9.96967 12.5303C10.1103 12.671 10.3011 12.75 10.5 12.75H12C12.1989 12.75 12.3897 12.671 12.5303 12.5303C12.671 12.3897 12.75 12.1989 12.75 12C12.75 11.8011 12.671 11.6103 12.5303 11.4697C12.3897 11.329 12.1989 11.25 12 11.25H10.5Z",
    fill: "#164988"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.f8a214a9c20751b5d8acd8d5ca53ab4b.svg";
export { ForwardRef as ReactComponent };